import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "五年后期制作经验",
          "精通动效制作",
          "擅长视频拍摄",
          "会一点点代码的剪辑狮",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
